module.exports = __webpack_public_path__ + "static/media/34DSS7.9424b300.jpg";